var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { styled } from '../theme-provider';
const StyledSlide = styled.div.withConfig({ displayName: "StyledSlide", componentId: "sc-zp10d9" }) `display:flex;flex:1 0 0;align-items:center;justify-content:center;user-select:none;pointer-events:none;`;
export const MediaGallerySlide = (_a) => {
    var { children, fullSize } = _a, rest = __rest(_a, ["children", "fullSize"]);
    if (fullSize) {
        return React.createElement(StyledSlide, Object.assign({}, rest), children);
    }
    return React.createElement(StyledSlide, Object.assign({}, rest), children);
};
